export const appEndpoint = {
  //Tana
   awards:'/awards',
   awardAreas:'/award-areas',
  getUser: `/getUser`,
  logout: '/logout',
  getUsers:'/users',
  addUser:'/users',
  updateUser:'/users',
  deleteUser: '/users',
  getBlogs:'/blogs',
  addBlog:'/blogs',
  updateBlog:'/blogs',
  deleteBlog: '/blogs',

  nominees:'/nominees',
 
 gallery:'/gallery',
 
 
  teamProfiles:'/team_profiles',
  subscribers:'/subscribers',
  changePassword:'/change-password',
  testimonials:'/testimonials',
  partners:'/partners',
  dashboardSummary:'/dashboard/summary',
  contactMessages: '/contact_messages',
  newsLetters:'/newsletter',
  sendNewsletter:'/newsletter/send',
};